export const DISCOVER_PAGE_BROWSE_DEFAULT_LIMIT = 18;
export const DISCOVER_PAGE_DEFAULT_LIMIT = 6;
